import React, { Component } from 'react'
import Rebase from 're-base'
import firebase from 'firebase'
import json2csv from 'json2csv'
import FileSaver from 'file-saver'

import Admin from './Admin'
import Header from './Header'
import Welcome from './Welcome'
import Scores from './Scores'
import Game from './Game'
import Notification from './Notification'
import './css/App.css'

const base = Rebase.createClass({apiKey: "AIzaSyALMDi-Wq6J6_oz-VFmFSH-Zn5vkMORozo", authDomain: "gamify-b97b1.firebaseapp.com", databaseURL: "https://gamify-b97b1.firebaseio.com", storageBucket: "gamify-b97b1.appspot.com"})

class App extends Component {

  constructor(props) {
    super(props)

    const protocol = window.location.protocol
    let pathname = null
    if(protocol === 'http:' || protocol === 'https:'){
      pathname = window.location.pathname.substr(1)
    }

    this.state = {
      screen: 'Welcome',
      scores: [],
      screenTimer: null,
      uid: null,
      day: parseInt(localStorage.getItem('currentDay'), 10) || 0,
      uidRequest: pathname,
      notify: null
    }

    this.keys = {}

    this.timeStamp = 0
  }

  componentWillMount() {
    if (localStorage.getItem('scores') && !this.state.uidRequest) {
      this.getLocalData()
    }
    if(this.state.uidRequest) {
      this.changeScreen('Scores')
      this.listenFirebase()
    }
  }

  componentDidUpdate() {
    if(!this.state.uidRequest){
      this.saveLocalData()
      this.saveFirebase()
    }
  }

  componentDidMount(){
    if(!this.state.uidRequest){
      this.firebaseAuth()
      this.welcomeTimer()
    }
    this.listenForKeys()
  }

  firebaseAuth(){
    if(!localStorage.getItem('hype-uid')){
      firebase.auth().signInAnonymously().catch(function(error) {
        console.log(error.message)
      })
    } else {
      const uid = localStorage.getItem('hype-uid')
      this.setState({ uid: uid })
    }
    firebase.auth().onAuthStateChanged( user => {
      if(user){
        const uid = user.uid;
        localStorage.setItem('hype-uid', uid)
        console.log('Signed in as', uid)
        this.setState({ uid: uid })
      }
    })
  }

  welcomeTimer(){
    window.clearTimeout(this.state.screenTimer)
    this.setState({
      screenTimer: setInterval(() => {
        if(this.state.screen === 'Welcome'){
          this.setState({screen: 'Scores'})
        } else if(this.state.screen === 'Scores') {
          this.setState({screen: 'Welcome'})
        }
      }, 20000)
    })
  }

  saveLocalDataToCSV(){
    if(!this.state.scores.length) return false
    try {
      const now = new Date()
      const csv = json2csv({ data: this.state.scores })
      this.saveFile(csv, `gartner-hype-cycle-scores-${ now.toISOString() }.csv`, 'text/csv')
    } catch (err) {
      console.error(err)
    }
  }

  listenForKeys(){
    window.onkeydown = window.onkeyup = e => {
      this.keys[e.keyCode] = e.type
      if(this.keys[17] === 'keydown' && this.keys[67] === 'keydown'){
        this.saveLocalDataToCSV()
        this.keys[17] = this.keys[67] = 'keyup'
      }
      if(this.keys[17] === 'keydown' && this.keys[65] === 'keydown'){
        this.changeScreen('Admin')
        this.keys[17] = this.keys[65] = 'keyup'
      }
    }
  }

  saveFile(text, name, type) {
    const blob = new Blob([text], {type: type})
    FileSaver.saveAs(blob, name)
  }

  saveLocalData() {
    console.log('saving local scores')
    const scores = JSON.stringify(this.state.scores)
    localStorage.setItem('scores', scores)
    const timeStamp = Date.now()
    this.timeStamp = timeStamp
    localStorage.setItem('scoresTimeStamp', Date.now())
    localStorage.setItem('currentDay', this.state.day)
  }

  getLocalData() {
    console.log('getting local scores')
    const scores = JSON.parse(localStorage.getItem('scores'))
    this.setState({scores: scores})
  }

  clearLocal() {
    console.log('clearing local scores')
    if (window.confirm("Do you really want to clear all scores?")) {
      localStorage.clear()
      this.setState({scores: []})
    }
    this.changeScreen('Welcome')
  }

  saveFirebase() {
    base.post(`users/${this.state.uid}/scores`, {data: this.state.scores}).then(() => {
      console.log('firebase updated successfully')
    }).catch(err => {
      console.log(err)
    })
    base.post(`users/${this.state.uid}/timestamp`, {data: this.timeStamp}).then(() => {
      console.log('firebase timeStamp updated successfully')
    }).catch(err => {
      console.log(err)
    })
  }

  listenFirebase() {
    console.log(`Asking firebase for user ${this.state.uidRequest}`)
    base.fetch('users', {
      context: this,
      asArray: true,
      then(data){
        const targetUser = data.find(user => user.key.substr(0, 6) === this.state.uidRequest)
        if(targetUser){
          base.bindToState(`users/${targetUser.key}/scores`, {
            context: this,
            state: 'scores',
            asArray: true
          })
        } else {
          this.setState({notify: `Couldn't find user ${this.state.uidRequest}`})
          console.log(`Couldn't find user ${this.state.uidRequest}`)
        }
      }
    })
  }

  addScore(data) {
    const id = this.state.scores.length ? this.state.scores[this.state.scores.length - 1].id + 1 : 0
    const newScore = {
      name: data.name || '',
      organisation: data.organisation || '',
      email: data.email || '',
      score: data.score || 0,
      id: id,
      day: this.state.day
    }
    this.setState(currentState => {
      return currentState.scores.push(newScore)
    })
    this.setState({screen: 'Scores'})
  }

  changeScreen(screen){
    this.setState({screen: screen})
  }

  changeDay(day){
    if(typeof day === 'number'){
      this.setState({day: day})
    }
  }

  renderScreen (){
    switch(this.state.screen){
      case 'Scores':
        return (
          <div className="AppWrap">
            <Scores
              scores={this.state.scores}
              addScore={this.addScore.bind(this)}
              clearLocal={this.clearLocal}
              />
          </div>
        )
      case 'Game':
        return <Game addScore={this.addScore.bind(this)} changeScreen={this.changeScreen.bind(this)}/>
      case 'Admin':
        return <Admin changeScreen={this.changeScreen.bind(this)}
          uid={this.state.uid}
          clearLocal={this.clearLocal.bind(this)}
          changeDay={this.changeDay.bind(this)}
          currentDay={this.state.day}
          saveCSV={this.saveLocalDataToCSV.bind(this)}
          scores={this.state.scores}
          />
      case 'Welcome':
        return <Welcome changeScreen={this.changeScreen.bind(this)}/>
      default:
        return <Game addScore={this.addScore.bind(this)} changeScreen={this.changeScreen.bind(this)}/>
    }
  }

  renderNotification(){
    if(this.state.notify){
      return <Notification text={this.state.notify} hide={() => this.setState({notify: null})}/>
    }
  }

  render() {
    return (
      <div className="App">
        <Header title={this.state.screen} changeScreen={this.changeScreen.bind(this)} />
          { this.renderScreen() }
          { this.renderNotification() }
      </div>
    )
  }
}

export default App



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/